import { NEXT_MUTATION_ENTITY } from '@common/interfaces/entity';
import { getCachedToken } from '@config/authentication';
import { createAsyncThunk } from '@reduxjs/toolkit';
import { RootState } from '@store';
import { selectOrderCustomerBosApiId, selectOrderId } from '@store/selectors';
import {
  setIsReserveLoading,
  setIsSalesWizardLoading,
  setReserveCancelModalStatus,
} from '@store/slices/salesWizardSlice';
import { refetchOrder } from './refetchOrder';
import { eventEmitter, Events } from '@utils';
import { mutateNextEntityWithToken } from '@utils/serverActions/clientUtility';
import { VehicleReserveStatus } from 'next-common';

export const setOrderReserveStatus = createAsyncThunk(
  'setOrderReserveStatus',
  async (
    args: { vehicleReserveStatus: VehicleReserveStatus; skipNextReservation: boolean },
    { dispatch, getState, rejectWithValue }
  ) => {
    const { vehicleReserveStatus, skipNextReservation } = args;
    dispatch(setReserveCancelModalStatus(false));
    dispatch(setIsReserveLoading(true));
    eventEmitter.dispatch(Events.DISABLE_RESERVE_BTN, true);
    const state = getState() as RootState;
    const orderId = selectOrderId(state);
    const customerId = selectOrderCustomerBosApiId(state);
    const variables = {
      id: orderId,
      status: VehicleReserveStatus[vehicleReserveStatus],
      customerId: customerId,
      skipNextReservation,
    };
    try {
      const reserveOrder = await mutateNextEntityWithToken(
        NEXT_MUTATION_ENTITY.RESERVE_VEIHICLE_ORDER,
        getCachedToken(),
        variables,
        undefined,
        orderId
      );
      if (!reserveOrder) {
        return rejectWithValue('Reservation failed');
      }

      await dispatch(refetchOrder(orderId))?.unwrap();
      dispatch(setIsSalesWizardLoading(false));
      return true;
    } catch (error) {
      return rejectWithValue(error);
    } finally {
      eventEmitter.dispatch(Events.DISABLE_RESERVE_BTN, false);
      dispatch(setIsReserveLoading(false));
    }
  }
);
